// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1_AQ7","inner":"Footer_inner__1w2Z3","nextIcon":"Footer_nextIcon__J8kkW","innerLeft":"Footer_innerLeft__2_GE_"};